export default {
  methods: {
    getFileIconFromMimeType(mimeType) {
      switch(mimeType.toLowerCase()) {
        case 'image/gif':
          // return '/images/document-types/gif.png';
        case 'image/png':
          // return '/images/document-types/png.png';
        case 'image/jpeg':
          // return '/images/document-types/jpg.png';
          return '/images/document-types/image.png'
        case 'folder':
          return '/images/document-types/folder.png'
          // case 'application/pdf':
          //     return '/images/document-types/pdf.png';
          // case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          //     return '/images/document-types/word.png';
          // case 'application/vnd.ms-excel':
          //     return '/images/document-types/excel.png';
          // case 'application/vnd.ms-powerpoint':
          //     return '/images/document-types/powerpoint.png';
          // case 'text/plain':
          //     return '/images/document-types/text.png';
          // case 'text/xml':
          //     return '/images/document-types/xml.png';
          // case 'text/csv':
          //     return '/images/document-types/csv.png';
          // case 'image/svg+xml':
          //     return '/images/document-types/svg.png';
        default:
          return '/images/document-types/document.png'
      }
    },
  },
}